import { useMemo } from "react";
import { Field } from "react-final-form";

import DollarInput from "../../inputs/DollarInput";
import RffInputWrapper from "../shared/RffInputWrapper";

const RffDollarField = ({
  name,
  label,
  required = false,
  helperText,
  placeholder,
  fullWidth,
  row = false,
  suppressGrid,
  onBlur,
  size,
  disabled,
  allowNegative = false,
  /** Shown under the control while the value is below zero (needs allowNegative). */
  negativeHelperText,
}) => {
  const validateDollarAmount = useMemo(() => {
    return (value) => {
      if (required && (value === undefined || value === null || value === "")) {
        return "This field is required";
      }

      return undefined;
    };
  }, [required]);

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      helperText={helperText}
      required={required}
      row={row}
    >
      <Field
        name={name}
        validate={validateDollarAmount}
        parse={(value) => {
          if (value === "") return undefined;
          if (value === null) return null;
          return value;
        }}
        render={({ input, meta }) => (
          <DollarInput
            {...input}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            fullWidth={fullWidth}
            allowNegative={allowNegative}
            error={meta.touched && !!meta.error}
            helperText={
              meta.touched && meta.error
                ? meta.error
                : allowNegative && negativeHelperText && Number(input.value) < 0
                  ? negativeHelperText
                  : null
            }
          />
        )}
      />
    </RffInputWrapper>
  );
};

export default RffDollarField;
